import { Component, OnInit } from '@angular/core';
import { CardComponent } from '@shared/components/card/card.component';
import { ValueDetailsComponent } from '@shared/components/value-details/value-details.component';
import { TableComponent } from '@shared/components/table/table.component';
import { AuthRoles, EstimationGroupDto, EstimationGroupMethodDto, VeeService } from '@app/api/dmc';
import { Columns } from '@shared/interfaces/table/column-config';
import { veeDetailsMasterdata } from '@shared/interfaces/masterdata/vee/vee-details.masterdata';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { veeMethodsTable } from '@shared/table-configs/vee/vee-methods.table';
import { HeaderService } from '@app/core/services/header.service';
import { VeeCreateEditModalComponent } from '@shared/modals/vee/vee-create-edit-modal/vee-create-edit-modal.component';
import { ModalService } from '@app/core/services/modal.service';
import { Pencil } from 'lucide-angular';
import { hasRole } from '@app/core/guards/has-role.guard';

@Component({
  selector: 'app-vee-overview',
  imports: [
    CardComponent,
    ValueDetailsComponent,
    TableComponent,
    TranslatePipe
  ],
  templateUrl: './vee-overview.component.html',
  styleUrl: './vee-overview.component.css'
})
export class VeeOverviewComponent implements OnInit {
  /** ID **/
  public id?: string;

  /** Master data **/
  public vee?: EstimationGroupDto;
  public veeCollection: Columns<EstimationGroupDto>[] = veeDetailsMasterdata;

  /** Table **/
  public veeTableConfig: TableConfig<EstimationGroupMethodDto> = veeMethodsTable

  public veeTableData: EstimationGroupMethodDto[] = [];

  constructor(
    private readonly veeService: VeeService,
    private readonly route: ActivatedRoute,
    private readonly headerService: HeaderService,
    private readonly modalService: ModalService,
  ) {
    const veeWriter = hasRole([AuthRoles.VEEWriter]);

    this.headerService.setActions([
      {
        id: 'edit',
        title: 'common.edit',
        icon: Pencil,
        callback: () => this.openEditModal(),
        disabled: () => !veeWriter
      }
    ])
  }

  public ngOnInit(): void {
    this.route.paramMap.subscribe((q: ParamMap) => {
      this.id = q.get('id')!;

      this.veeService.veeGetByIdGet(this.id).subscribe((data: EstimationGroupDto) => {
        this.vee = data;

        this.veeTableData = data.estimationMethods
          ? data.estimationMethods.sort((a, b) => (a.sortorder ?? 0) - (b.sortorder ?? 0))
          : [];
      });
    });
  }

  public openEditModal(): void {
    this.modalService.show({
      component: VeeCreateEditModalComponent,
      title: 'vee.editModal.title',
      actions: [
        { type: 'primary', label: 'system.button.edit', method: 'submit' },
        { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
      ],
      params: {
        id: this.vee?.id,
        vee: this.vee
      }
    }).subscribe(() => {
      this.fetchData()
    })
  }

  public fetchData(): void {
    if (!this.id) return;
    this.veeService.veeGetByIdGet(this.id).subscribe((data: EstimationGroupDto) => {
      this.vee = data;
    });
  }
}
